<template>
	<div class="section logout">
		<div class>
			<h3>{{ $t('Logout') }}</h3>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Logout',
	metaInfo () {
		return {
			title: this.$t("Logout"),
			meta: [
				{ name: 'robots', content: 'noindex' },
			]
		}
	},
	methods: {
		logout: function () {
			var _this = this
			console.log('+XXX')
			localStorage.removeItem('loggedIn')
			localStorage.removeItem('token')
			this.$http.post('/users/logout', this.user).then(() => {
				_this.$store.commit('setUser', {})
				_this.$store.commit('setLoggedIn', false)
				localStorage.setItem('logout', true)
				window.location.href = '/'
			})
		},
	},
	mounted() {
		this.logout()
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
	font-weight: normal;
}
ul {
	list-style-type: none;
	padding: 0;
}
li {
	display: inline-block;
	margin: 0 10px;
}
a {
	color: #42b983;
}
</style>
